import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/Event/KTechPioneers/List/index.tsx");
